import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Nursery } from 'app/models/Nursery';
import { faMapMarker, faGlobe, faPhone, faClock } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-nursery-list',
  templateUrl: './nursery-list.component.html',
  styleUrls: ['./nursery-list.component.scss']
})
export class NurseryListComponent {
  @Input() nurseries: Nursery[] = [];
  @Input() sortBy: string = 'name';
  @Input() keyword: string = '';
  @Output() sortByChange = new EventEmitter<string>();

  faMapMarker = faMapMarker;
  faGlobe = faGlobe;
  faPhone = faPhone;
  faClock = faClock;

  sortNurseries() {
    this.sortByChange.emit(this.sortBy);
  }
}
